/** * 订单管理 交易订单 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>提现管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search">
      <el-form-item label="用户昵称：">
        <el-input
          size="small"
          v-model="userName"
          placeholder="输入用户昵称"
        ></el-input>
      </el-form-item>
      <el-form-item label="电话号码：">
        <el-input
          size="small"
          v-model="phone"
          placeholder="输入电话号码"
        ></el-input>
      </el-form-item>

      <el-form-item label="提现状态:">
        <el-select size="small" v-model="status" placeholder="请选择">
          <el-option
            v-for="(type, index) in payType"
            :label="type.key"
            :value="type.value"
            :key="index"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%;"
    >
      <el-table-column
        align="center"
        type="index"
        width="60"
        label="序号"
      ></el-table-column>
      <el-table-column
        align="center"
        sortable
        prop="userName"
        label="用户"
        width="100"
      ></el-table-column>
      <el-table-column
        align="center"
        sortable
        prop="phone"
        label="手机号"
        width="100"
      ></el-table-column>
      <el-table-column
        align="center"
        sortable
        prop="status"
        label="状态"
        width="140"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0">待审核</div>
          <div v-if="scope.row.status == 1">提现成功</div>
          <div v-if="scope.row.status == 2">驳回</div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        sortable
        prop="money"
        label="提现钻石数"
        width="140"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div>{{ scope.row.money }}</div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        sortable
        prop="payoutWay"
        label="提现方式"
        width="140"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-if="scope.row.payoutWay == 0">支付宝</div>
          <div v-if="scope.row.payoutWay == 1">银行卡</div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        sortable
        prop="remark"
        label="驳回原因"
        width="140"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        sortable
        prop="alipayAccount"
        label="支付宝账号"
        width="140"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        sortable
        prop="alipayNickname"
        label="支付宝名称"
        width="140"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        sortable
        prop="addTime"
        label="创建时间"
        width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="操作"
        min-width="240"
        fixed="right"
      >
        <template slot-scope="scope" v-if="scope.row.status == 0">
          <el-button size="mini" @click="setWithdraw(scope.$index, scope.row)"
            >确认打款</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="cancelWithdraw(scope.$index, scope.row)"
            >驳回</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑界面 -->
    <el-dialog title="驳回原因" :visible.sync="editFormVisiible" width="40%">
      <el-form label-width="120px">
        <el-form-item label="驳回原因">
          <el-input
            size="small"
            v-model="remark"
            auto-complete="off"
            placeholder="请输入驳回原因"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog()">取消</el-button>

        <el-button
          size="small"
          type="primary"
          :loading="loading"
          @click="saveWithdraw()"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
  </div>
</template>

<script>
import { payoutsList, aduitPayout } from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      id: "",
      remark: "", //驳回原因
      loading: false, //是显示加载
      editFormVisiible: false, //控制编辑页面显示与隐藏
      title: "预览",
      userKey: "",
      status: "",
      payType: [
        { key: "全部", value: "-1" },
        { key: "待审核", value: "0" },
        { key: "提现成功", value: "1" },
        { key: "提现失败", value: "2" }
      ],
      rate: "",
      formInline: {
        page: 1,
        limit: 10,
        machineNo: "",
        orderNo: "",
        transId: "",
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem("logintoken")
      },

      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      },
      userName: "",
      phone: "",
      payoutWay: ""
    };
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getWithdrawList(1);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取列表
    getWithdrawList(page) {
      this.loading = true;
      var parameter = {
        userName: this.userName,
        phone: this.phone,
        payoutWay: this.payoutWay,
        status: this.status,
        page: (page - 1) * 20
      };
      console.log("parameter", parameter);
      payoutsList(parameter).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.list;
          //   this.rate = res.data.rate/100;
          this.pageparm.currentPage = page;
          this.pageparm.total = res.data.count;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg
        });
      });
    },
    // 设置提现手续费
    setServiceCharge() {
      this.loading = true;
      var parameter = {
        rate: this.rate * 100,
        id: 1
      };
      setServiceCharge(parameter).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg
          });
          return;
        }
        this.$message({
          type: "info",
          message: res.msg
        });
      });
    },

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getWithdrawList(parm.currentPage);
    },
    // 搜索事件
    search() {
      this.getWithdrawList(1);
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    closeDialog() {
      this.editFormVisiible = false;
    },
    cancelWithdraw(index, row) {
      this.editFormVisiible = true;
      this.remark = "";
      this.id = row.id;
    },
    saveWithdraw() {
      aduitPayout({
        id: this.id,
        status: 2,
        remark: this.remark
      }).then(res => {
        this.editFormVisiible = false;
        if (res.code == 200) {
          this.getWithdrawList(1);
        } else {
          this.$message({
            type: "info",
            message: res.msg
          });
        }
      });
    },
    setWithdraw(index, row) {
      this.$confirm("确定已经打款了吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          aduitPayout({ id: row.id, status: 1 })
            .then(res => {
              if (res.code == 200) {
                this.getWithdrawList(1);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg
                });
              }
            })
            .catch(err => {
              this.loading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/terrace/Withdraw.vue